import { handleRequest } from "../utilities/requestHandler";

export const processModel = (endpoint, filename, machineName, currency, userId, productNumbers, machineId, baseColor, selectedSite, machineNumber, engine, siteId, customerId) =>
    handleRequest("post", endpoint, {
        filename: filename,
        machinename: machineName,
        currency: currency,
        loggedinUser: userId,
        productNumbers: productNumbers,
        ecommachineid: machineId,
        baseColor: baseColor,
        selectedSite: selectedSite,
        machinenumber: machineNumber,
        site_id: siteId || "",
        cus_id: customerId || "",
        ...(engine ? { engine } : {}),
    });
